module.exports = __webpack_public_path__ + "img/009-boy-4.0a2fab5b.svg";